export function encodeWithSalt(value: string): string {
  const salt = Math.random().toString(36).substring(2, 8); // random 6 chars
  const combined = salt + ":" + value;
  return btoa(combined);
}

export function decodeWithSalt(encoded: string): string | null {
  try {
    const decoded = atob(encoded);
    const parts = decoded.split(":");
    if (parts.length === 2) {
      return parts[1]; // actual value without salt
    }
    return null;
  } catch {
    return null;
  }
}
